module.exports = __webpack_public_path__ + "static/media/share-04.ac16b687.svg";